module.exports = __webpack_public_path__ + "08be3657382bcb8fd77e1a9391e53675.png";